// "SNACK_TIME_RED_PACKAGE_TEST": 100023,  "SNACK_TIME_RED_PACKAGE": 100024
export const pageTag = 'TIMING_RED_PACKET_H5';
// export const activityId = '100023';
// export const activityName = 'SNACK_TIME_RED_PACKAGE_TEST';
export const activityId = '100024';
export const activityName = 'SNACK_TIME_RED_PACKAGE';
export const onelink = 'https://go.onelink.me/kQdi/SNACKREDPACKAGE';

export const watchTime = [
  { val: 200, time: 2, isGift: false },
  { val: 500, time: 10, isGift: false },
  { val: 1000, time: 20, isGift: false },
  { val: 1500, time: 30, isGift: true },
  { val: 1000, time: 60, isGift: false },
  { val: 2000, time: 90, isGift: true },
  { val: 3000, time: 120, isGift: false },
];

export const signInList = {
  0: {
    top: [
      { val: 500, time: 1, isGift: false, v2: 10 },
      { val: 1000, time: 2, isGift: false, v2: 20 },
      { val: 2000, time: 3, isGift: false, v2: 40 },
      { val: 500, time: 4, isGift: false, v2: 10 },
      { val: 1000, time: 5, isGift: false, v2: 20 },
      { val: 500, time: 6, isGift: false, v2: 10 },
    ],
    bottom: [
      { val: 3999, time: 7, isGift: true, v2: 79.98 },
      { val: 5999, time: 14, isGift: true, v2: 119.98 },
      { val: 7999, time: 21, isGift: true, v2: 159.98 },
      { val: 9999, time: 30, isGift: true, v2: 199.98 },
    ],
  },
  1: {
    top: [
      { val: 3999, time: 7, isGift: true, v2: 79.98 },
      { val: 500, time: 8, isGift: false, v2: 10 },
      { val: 500, time: 9, isGift: false, v2: 10 },
      { val: 1000, time: 10, isGift: false, v2: 20 },
      { val: 500, time: 11, isGift: false, v2: 10 },
      { val: 1000, time: 12, isGift: false, v2: 20 },
    ],
    bottom: [
      { val: 500, time: 13, isGift: false, v2: 10 },
      { val: 5999, time: 14, isGift: true, v2: 119.98 },
      { val: 7999, time: 21, isGift: true, v2: 159.98 },
      { val: 9999, time: 30, isGift: true, v2: 199.98 },
    ],
  },
  2: {
    top: [
      { val: 5999, time: 14, isGift: true, v2: 119.98 },
      { val: 500, time: 15, isGift: false, v2: 10 },
      { val: 500, time: 16, isGift: false, v2: 10 },
      { val: 1000, time: 17, isGift: false, v2: 20 },
      { val: 500, time: 18, isGift: false, v2: 10 },
      { val: 2000, time: 19, isGift: false, v2: 40 },
    ],
    bottom: [
      { val: 500, time: 20, isGift: false, v2: 10 },
      { val: 7999, time: 21, isGift: true, v2: 159.98 },
      { val: 9999, time: 30, isGift: true, v2: 199.98 },
    ],
  },
  3: {
    top: [
      { val: 7999, time: 21, isGift: true, v2: 159.98 },
      { val: 500, time: 22, isGift: false, v2: 10 },
      { val: 500, time: 23, isGift: false, v2: 10 },
      { val: 1000, time: 24, isGift: false, v2: 20 },
      { val: 500, time: 25, isGift: false, v2: 10 },
      { val: 2000, time: 26, isGift: false, v2: 40 },
    ],
    bottom: [
      { val: 500, time: 27, isGift: false, v2: 10 },
      { val: 2000, time: 28, isGift: false, v2: 40 },
      { val: 500, time: 29, isGift: false, v2: 10 },
      { val: 9999, time: 30, isGift: true, v2: 199.98 },
    ],
  },
};
export const langKey = [
  // 'act_time_redeem',
  // 'act_time_redeem_btn',
  // 'act_time_equal',
  // 'act_time_slogan',
  // 'newyear_58359',
  'newyear_58325',
  'act_time_unsign_desc',
  'act_time_signed_desc',
  'act_time_unsign_btn',
  'act_time_signed_btn',
  'newyear_58318',
  // 'act_time_upgrade',
  // 'act_time_upgrade_desc',
  // 'act_time_toast',
  'act_time_sign_pop_title',
  // 'act_time_sign_toast_title',
  'act_time_sign_toast',
  // 'act_time_guide1',
  // 'act_time_guide2',
  // 'act_time_guide3',
  // 'act_time_random1',
  // 'act_time_random2',
  // 'act_time_random3',
  // 'act_time_random4',
  // 'act_time_random5',
  // 'download_now',
  'act_time_watch_title',
  'act_time_watch_desc',
  // 'act_time_watch_btn1',
  // 'act_time_title',
  // 'act_time_outside',
  // 'act_time_outside_btn',
  'act_time_wrong',
  // 'activity_end',
  'act_time_app_upgrade_title',
  'act_time_app_upgrade_desc',
  'act_time_app_upgrade_btn',
  // 'act_time_outside_title',
  'time_coin_new_watch',
  'time_coin_new_praise',
  'time_coin_new_follow2',
  'newyear_big_prize_58544',
  'newyear_58441',
  'act_time_new_user',
  'act_time_limit_task',
  'act_time_copy',
  'act_time_invite',
  'act_time_invite_title',
  'act_time_invite_btn',
  'act_time_invite_rule1',
  'act_time_invite_rule2',
  'act_time_invite_rule3',
  'act_time_invite_placeholder',
  'act_time_invite_desc',
  'act_time_invite_done',
  'act_time_invite_bind',
  'act_time_code_title',
  'act_time_code_title_done',
  'act_time_code_done',
  'act_time_code_desc',
  'act_time_code',
  'act_time_gift',
  'coin_my',
  'coin_withdraw',
  'code_error_msg',
  'invitee_bind_btn_content',
  'act_time_bind_title',
  'invitee_bind_link_content',
  'act_time_deadline',
  'pro_wallet_cash_network_error',
  'act_time_unsign_desc1',
  'act_time_signed_desc1',
  'act_time_sign_pop_title1',
  'act_time_sign_toast1',
  'coin_my1',
];

export type LangType = { [key in typeof langKey[number]]: string };
